import { Modules } from "./moduleContext.reducer"

export enum Types {
  CHANGE_MODULE = "CHANGE_MODULE",
  CHANGE_MODULE_SUCCESS = "CHANGE_MODULE_SUCCESS",
}

export type ChangeModuleAction = {
  type: Types.CHANGE_MODULE
  payload: { module: Modules }
}

export type ChangeModuleActionSuccess = {
  type: Types.CHANGE_MODULE_SUCCESS
  payload: { module: Modules }
}

export type Action = ChangeModuleAction | ChangeModuleActionSuccess

export function changeModule(module: Modules): ChangeModuleAction {
  return {
    payload: { module },
    type: Types.CHANGE_MODULE,
  }
}

export function changeModuleSuccess(module: Modules): ChangeModuleActionSuccess {
  return {
    type: Types.CHANGE_MODULE_SUCCESS,
    payload: { module },
  }
}
